import { CardSimple } from "../components/UI/Card";
import { UserIcon } from "lucide-react";
import NewMeetingButton from "../components/NewMeetingButton";
import MeetingHistory from "../components/MeetingHistory";
import { useParams } from "react-router-dom";
import IncomeVsExpenses from "../charts/IncomeVsExpenses";
import CompletedTasksTable from "../components/CompletedTasksTable";
import FamilyProfile from "./FamilyProfile";

const FamilyDashboard = () => {
  const { id: familyId } = useParams<{ id: string }>();

  return (
    <div className="p-6 min-h-screen text-right font-sans bg-background text-text-main">
      <header className="text-center mb-8">
        <h1 className="text-3xl font-bold text-primary">לוח משפחה</h1>
      </header>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8 items-start">
        <CardSimple className="flex flex-col items-center text-center p-6">
          <div className="mb-4">
            <UserIcon className="w-8 h-8 text-gray-600" />
          </div>

          <FamilyProfile />
          <NewMeetingButton />
        </CardSimple>
        <CardSimple className="lg:col-span-2 p-4 w-full max-h-[420px]">
          {familyId && <IncomeVsExpenses familyId={familyId} />}
        </CardSimple>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <CardSimple className="p-4">
          <CompletedTasksTable />
        </CardSimple>
        <CardSimple className="p-4">
          <MeetingHistory familyId={familyId!} />
        </CardSimple>
      </div>
    </div>
  );
};

export default FamilyDashboard;
